import React, { useState, useEffect } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import Time from "../components/time";
import { useParams, Link} from "react-router-dom";
import Swal from "sweetalert2";

const SupplierView = () => {
   useAuthRedirect();
  const { sCode } = useParams();
  const branch = localStorage.getItem("branch");
  const user = localStorage.getItem("username");
  const [code, setCode] = useState(""); 
  const [subDetails, setSubDetails] = useState({});
  const [formData, setFormData] = useState({
    price: "",
    disc: "",
    pf: "",
    gst: ""
  });

  useEffect(() => {
    const fetchSupplierDetails = async () => {
      try {

         Swal.fire({
                        title: "Fetching Supplier Details",
                        html: `
                          <div style="width: 100%; background: #e0e0e0; border-radius: 5px;">
                            <div style="height: 10px; width: 0%; background: linear-gradient(to right, #4facfe, #00f2fe); animation: progressBar 2s linear infinite;"></div>
                          </div>
                          <p style="margin-top: 10px; font-size: 14px;">Please wait while we fetch Category Code...</p>
                        `,
                        showConfirmButton: false,
                        allowOutsideClick: false,
                        didOpen: () => {
                          const style = document.createElement("style");
                          style.innerHTML = `
                            @keyframes progressBar {
                              0% { width: 0% }
                              50% { width: 100% }
                              100% { width: 0% }
                            }
                          `;
                          document.head.appendChild(style);
                        },
                      });


        const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/supplierMaster_fetchSubData?sCode=${sCode}`);
        const items = response.data.modifySupplier;
  
        if (items.length > 0) {
          const item = items[0];
          const storeReqHeader1 = {
            sName: item.supplierMaster_name || "N/A",
            address1: item.supplierMaster_addressline1 || "N/A",
            address2: item.supplierMaster_addressline2,
            city: item.supplierMaster_city,
            pinCode: item.supplierMaster_pincode,
            phone: item.supplierMaster_phoneNumber,
            email: item.supplierMaster_email,
            fax: item.supplierMaster_faxNumber,
            pan: item.supplierMaster_webSite,
            gst: item.supplierMaster_taxpercentage,
            rcNo: item.supplierMaster_rcNumber,
            rcDate: item.supplierMaster_rcDate,
            gstNo: item.supplierMaster_cstNumber,
            gstDate: item.supplierMaster_cstDate,
            disc: item.supplierMaster_DiscountPercentage,
            taxType: item.supplierMaster_taxtype,
            payment: item.supplierMaster_paymentMethod,
            delivery: item.supplierMaster_deliveryMethod,
            pf: item.supplierMaster_PFPercentage,
            insurance: item.supplierMaster_insuranceMethod,
            supplierMaster: item.supplierMaster_type,
            ecc: item.supplierMaster_eccNumber,
            remarks: item.supplierMaster_remarks,
          };
  
          setSubDetails(storeReqHeader1);
          setFormData({
            sName: storeReqHeader1.sName,
            address1: storeReqHeader1.address1,
            address2: storeReqHeader1.address2,
            city: storeReqHeader1.city,
            pinCode: storeReqHeader1.pinCode,
            phone: storeReqHeader1.phone,
            email: storeReqHeader1.email,
            gst: storeReqHeader1.gst,
            fax: storeReqHeader1.fax,
            pan: storeReqHeader1.pan,
            rcNo: storeReqHeader1.rcNo,
            rcDate: storeReqHeader1.rcDate,
            gstNo: storeReqHeader1.gstNo,
            gstDate: storeReqHeader1.gstDate,
            disc: storeReqHeader1.disc,
            taxType: storeReqHeader1.taxType,
            payment: storeReqHeader1.payment,
            delivery: storeReqHeader1.delivery,
            pf: storeReqHeader1.pf,
            insurance: storeReqHeader1.insurance,
            supplierMaster: storeReqHeader1.supplierMaster,
            ecc: storeReqHeader1.ecc,
            remarks: storeReqHeader1.remarks,
          });
        }
        Swal.close();
      } catch (error) {
        Swal.close();
                     console.error("Error fetching Supplier Details. Please try again:", error);
                     Swal.fire({
                       icon: "error",
                       title: "Oops!",
                       text: "Error fetching Supplier Details. Please try again",
                     });
      }
    };
  
    fetchSupplierDetails();
}, [sCode]);

 
  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right">
        <section>
           <div className="back-div">
          <h2 className="add-txt">Supplier Master - View</h2>
          <Link to='/inventory/supplierMasterView'><p className="back-button"><i className="fa-solid fa-backward"></i>Back</p></Link>
          </div>
          <Time />
        </section>

        <div className="form-container">
          <form className="vehicle-form" >
            <div className="form-row">
              <div className="form-group">
                <label>Name :</label>
                <input type="text" name="sName" value={formData.sName} readOnly/>
              </div>
              <div className="form-group">
                <label>Supplier Code :</label>
                <input type="text" name="sCode" value={sCode} readOnly/>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Address 1 :</label>
                <input type="text" name="address1" value={formData.address1} readOnly/>
              </div>
              <div className="form-group">
                <label>Address 2 :</label>
                <input type="text" name="address2" value={formData.address2} readOnly />
              </div>
            </div>
            
            <div className="form-row">
              <div className="form-group">
                <label>City :</label>
                <input type="text" name="city" value={formData.city} readOnly />
              </div>
              <div className="form-group">
                <label>PinCode :</label>
                <input type="text" name="pinCode" value={formData.pinCode} readOnly />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Phone :</label>
                <input type="text" name="phone" value={formData.phone} readOnly />
              </div>
              <div className="form-group">
                <label>Email :</label>
                <input type="text" name="email" value={formData.email} readOnly />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Fax :</label>
                <input type="text" name="fax" value={formData.fax} readOnly />
              </div>
              <div className="form-group">
                <label>PAN :</label>
                <input type="text" name="pan" value={formData.pan} readOnly />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>TIN Number :</label>
                <input type="text" name="rcNo" value={formData.rcNo} readOnly />
              </div>
              <div className="form-group">
                <label>RC Date :</label>
                <input
  type="text"
  name="rcDate"
  value={
    formData.rcDate
      ? new Date(formData.rcDate).toLocaleDateString("en-GB") // "dd/mm/yyyy"
      : ""
  }
  readOnly
/>

               
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>GST Number :</label>
                <input type="text" name="gstNo" value={formData.gstNo} readOnly />
              </div>
              <div className="form-group">
                <label>GST Date :</label>
                <input
  type="text"
  name="gstDate"
  value={
    formData.gstDate
      ? new Date(formData.gstDate).toLocaleDateString("en-GB") // "dd/mm/yyyy"
      : ""
  }
  readOnly
/>

              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Tax Type :</label>
                <input type="text" name="taxType" value={formData.taxType} readOnly />
              </div>
              <div className="form-group">
                <label>Tax % :</label>
                <input type="text" name="gst" value={formData.gst} readOnly />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Discount % :</label>
                <input type="text" name="disc" value={formData.disc} readOnly />
              </div>
              <div className="form-group">
                <label>PF % :</label>
                <input type="text" name="pf" value={formData.pf} readOnly />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Payment :</label>
                <input type="text" name="payment" value={formData.payment} readOnly />
              </div>
              <div className="form-group">
                <label>Delivery :</label>
                <input type="text" name="delivery" value={formData.delivery} readOnly />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Insurance :</label>
                <input type="text" name="insurance" value={formData.insurance} readOnly />
              </div>
              <div className="form-group">
                <label>ECC Number :</label>
                <input type="text" name="ecc" value={formData.ecc} readOnly />
              </div>
            </div>

            <div className="form-row">
            <div className="form-group">
                <label>Remarks :</label>
                <input type="text" name="remarks" value={formData.remarks} readOnly />
              </div>
              <div className="form-group">
                <label>Supplier Type :</label>
                <input type="text" name="supplierMaster" value={formData.supplierMaster} readOnly />
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SupplierView;
